module.exports = __webpack_public_path__ + "img/about-main-bkg.png";